export default "__VITE_ASSET__BCVPVGQW__"